import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { newsApi } from '../utils/api';
import PageHeader from '../components/common/PageHeader';
import NewsCard from '../components/common/NewsCard';
import LatestNews from '../components/common/LatestNews';
import AdBanner from '../components/common/AdBanner';
import PageLoader from '../components/common/PageLoader';

function CategoryPage({ onOpen }) {
  const { slug } = useParams();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const res = await newsApi.getAll({ category: slug, limit: 24 });
        if (mounted) setNews(res.data || []);
      } catch (e) {
        console.error('Error fetching category news:', e);
        if (mounted) setNews([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [slug]);

  if (loading) {
    return (
      <main className="max-w-[1240px] mx-auto px-5 pt-7 w-full">
        <PageLoader />
      </main>
    );
  }

  const title = news[0]?.category_name || 'समाचार';

  return (
    <main className="max-w-[1240px] mx-auto px-5 pt-7 pb-[60px] w-full">
      <PageHeader
        title={title}
        subtitle={`${title} सम्बन्धी ताजा तथा विश्वसनीय समाचारहरू।`}
        crumbs={['गृहपृष्ठ', title]}
      />

      <div className="grid gap-8 lg:grid-cols-[1fr_340px] items-start">
        <div className="min-w-0">
          {news.length > 0 ? (
            <div className="grid gap-7 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
              {news.map((n) => (
                <NewsCard key={n.id} item={n} onOpen={onOpen} />
              ))}
            </div>
          ) : (
            <p className="text-muted">यो विधामा हाल कुनै समाचार छैन।</p>
          )}
        </div>

        <aside className="flex flex-col gap-6 lg:sticky lg:top-24 min-w-0">
          <LatestNews items={news.slice(0, 5)} onOpen={onOpen} />
          <AdBanner position="sidebar" />
        </aside>
      </div>
    </main>
  );
}

export default CategoryPage;
